import { ToastService } from '@ihm-software/ihm-ui-common-angular-10';
import { ConfigApiResult, ConfigService } from './config.service';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Observable, fromEvent, merge } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { debounceTime, distinctUntilChanged, startWith, tap, delay, catchError } from 'rxjs/operators';
import { forkJoin, BehaviorSubject } from 'rxjs';
import { MultiDropboxComponent, MultiDropboxData, DatePickerComponent, DataTableComponent } from '../shared';
import { FormControl, FormGroup } from '@angular/forms';

import { UsersDataSource, UserInGrid } from './search-users-data-source';
import { UsersApiResult, UsersSearchService } from './users-search.service';
import { SilenceLogsService } from './silence-logs.service';
import { Profile, Role, ProfileConfig, ProfileRole, ProfileModelService } from '../profile/profile-model.service';
import { ProfileService } from '../profile/profile.service';
import { ColumnConfig, DynamicTableComponent } from 'material-dynamic-table';

// ag-grid
import { AgGridAngular } from 'ag-grid-angular';
import 'ag-grid-enterprise';
import { IDatasource, IGetRowsParams } from 'ag-grid-community';
import { MessageService } from './edit-cell.component';

export interface TransDayItem {
  name: string;
  value: number;
}

export interface SortData {
  active: string;
  direction: string;
}

export interface PaginatorData {
  pageIndex: number;
  pageSize: number;
}



@Component({
  selector: 'app-settings-notify-dialog',
  templateUrl: 'settings-notify-dialog.html',
  styleUrls: []
})
export class NotificationDialogComponent {
  dataObj = {
    closeModal: true
  };
  constructor(
    public dialogConfimRef: MatDialogRef<NotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onCancelConfirm(): void {
    this.dialogConfimRef.close();
  }
}

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  providers: [UsersSearchService, SilenceLogsService, ConfigService]
})
export class SettingsComponent implements OnInit, AfterViewInit {

  updateButtonText = 'UPDATE';
  cancelButtonText = 'CANCEL';

  editUserMode = false;
  userToEdit: UserInGrid = {
    email: '',
    name: '',
    role: Role.ADMIN,
    edit: ''
  };

  config: ConfigApiResult;

  transDays: TransDayItem[] = [
    { 'name': '60 Day(s)', 'value': 60 },
    { 'name': '90 Day(s)', 'value': 90 },
    { 'name': '120 Day(s)', 'value': 120 },
  ];

  announcementsForm: FormGroup;
  @ViewChild('datePicker',{static: true}) datePicker: DatePickerComponent;

  // Expansion Panel related from here !!
  openedPanel: Role;

  // Data grid related vars
  sort: MatSort;
  paginator: MatPaginator;

  currentUserEmail: string;

  standardUsersDataSource: UsersDataSource = new UsersDataSource();
  @ViewChild('standardUsersSearchInput',{static: true}) standardUsersSearchInput: ElementRef;
  stdPanelText = 'Standard Users';
  @ViewChild('standardUsersGrid',{static: true}) standardUsersGrid: DataTableComponent<UserInGrid>;
  totalStandardUsers = 0;

  adminUsersDataSource: UsersDataSource = new UsersDataSource();
  @ViewChild('adminUsersSearchInput',{static: true}) adminUsersSearchInput: ElementRef;
  admPanelText = 'Administrators';
  @ViewChild('adminUsersGrid',{static: true}) adminUsersGrid: DataTableComponent<UserInGrid>;
  totalAdminUsers = 0;

  defaultPageSize = 10;
  displayedColumns: string[] = ['name', 'email', 'edit'];
  noResultMessage: string;

  // ag-grid
  title = 'Silence Detection';
  @ViewChild('silenceLogsGrid',{static: true}) agGrid: AgGridAngular;
  defaultColDef = {
    resizable: true,
    sortable: true,
    menuTabs: ['generalMenuTab', 'filterMenuTab'],
    filter: 'agTextColumnFilter'
  };
  columnDefs = [
      {
        headerName: 'Timestamp',
        field: 'loggedTimeStamp',
        filter: 'agDateColumnFilter',
        checkboxSelection: false,
        width: 250,
        suppressSizeToFit: true
      },
      {
        headerName: 'Station',
        field: 'stationName'
      },
      {
        headerName: 'Segment Start Time',
        field: 'segmentStartDateTime'
      },
      {
        headerName: 'Segment End Time',
        field: 'segmentEndDateTime'
      },
      {
        headerName: 'Duration (sec)',
        field: 'secondsOfSilence'
      }
  ];

  rowData = [];

  gridApi;

  @ViewChild('standardUsersTable', { static: true }) standardUsersTable: DynamicTableComponent;
  @ViewChild('adminUsersTable', { static: true }) adminUsersTable: DynamicTableComponent;

  onGridReady(params) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.gridApi.setDatasource(this.dataSource);
  }

  dataSource: IDatasource = {
    getRows: (params: IGetRowsParams) => {
      const pageSize = 10;
      const pageNumber = params.endRow / pageSize;
      let sortKey = null;
      let sortOrder = 'DESC';
      if (params && params.sortModel && (params.sortModel.length > 0)) {
        sortKey = params.sortModel[0].colId;
        sortOrder = (params.sortModel[0].sort + '').toUpperCase();
      }
      this.silenceApi.findLogs(null, sortKey, sortOrder, pageNumber, pageSize)
      .toPromise()
      .then((response) => {
        params.successCallback(
          response.silenceDetectionDtoList, response.totalRows
        );
      })
      .catch(err => {
        params.successCallback(
          [], null
        );
      });
    }
  }

  isConnected = false;
  status: string;
  editClickedSubscription: any;

  // standard users columns
  standardUsersColumns: ColumnConfig[] = [
    {
      name: 'name',
      displayName: 'Name',
      type: 'string'
    },
    {
      name: 'email',
      displayName: 'Email',
      type: 'string'
    },
    {
      name: 'edit',
      displayName: '',
      type: 'edit'
    }  
  ];

  constructor(
    private usersSearchService: UsersSearchService,
    private profileService: ProfileService,
    private profileModelService: ProfileModelService,
    private titleService: Title,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private silenceApi: SilenceLogsService,
    private messageService: MessageService,
    private configService: ConfigService,
    private toastService: ToastService,
  ) {
    this.announcementsForm = new FormGroup({
      startTime: new FormControl(''),
      endTime: new FormControl('')
    });
    this.titleService.setTitle('SIA (Search, Index, Archive) - Administration');  
    this.editClickedSubscription = this.messageService.getMessage().subscribe(user => this.editUser(user)) 
  }
  ngOnDestroy() {
    this.editClickedSubscription.unsubscribe();
  }

  ngOnInit() {
    this.currentUserEmail = this.profileModelService.getProfile().token;
    this.configService.findLifecycle().subscribe((config: ConfigApiResult)=> this.config = config);
  }

  ngAfterViewInit() {
    fromEvent(this.standardUsersSearchInput.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.search();
        })
      )
      .subscribe();

    fromEvent(this.adminUsersSearchInput.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.search();
        })
      )
      .subscribe();

    setTimeout(() => this.search(Role.ADMIN), 100);
    setTimeout(() => this.search(Role.STANDARD), 100);
    
    this.standardUsersTable.sort.sortChange.subscribe(() => this.paginator ? (this.paginator.pageIndex = 0) : 0);
    merge(this.standardUsersTable.sort.sortChange, this.standardUsersTable.paginator.page)
      .pipe(
          tap(() => {
            this.sort = this.standardUsersTable.sort;
            this.paginator = this.standardUsersTable.paginator;
            return this.refreshGrid();
          })
        ).subscribe();
    
    this.adminUsersTable.sort.sortChange.subscribe(() => this.paginator ? (this.paginator.pageIndex = 0) : 0);
    merge(this.adminUsersTable.sort.sortChange, this.adminUsersTable.paginator.page)
      .pipe(
          tap(() => {
            this.sort = this.adminUsersTable.sort;
            this.paginator = this.adminUsersTable.paginator;
            return this.refreshGrid();
          })
        ).subscribe();
  }

  updateLifecycle(){
    if(parseInt(this.config.value) > 365){
      this.toastService.showToastMessage('Lifecycle can not be greater than 365 days!', 'error');
    }else{
      this.configService.updateConfig(this.config.key, this.config.value)
        .subscribe((updated)=>{
          if(updated.value == this.config.value){
            this.toastService.showToastMessage('Lifecycle updated successfully!', 'Ok');
          }
      }, (error)=>{
        this.toastService.showToastMessage('Something went wrong!', 'error');
        console.log(error);
      });
    }
  }

  refreshAdminUsers() {
    const sort = this.adminUsersGrid.getSort();
    const paginator = this.adminUsersGrid.getPaginator();
    const results: Observable<UsersApiResult> = this.usersSearchService.findUsers(
      this.adminUsersSearchInput.nativeElement.value,
      Role.ADMIN,
      sort ? (sort.active === 'name' ? 'userName' : 'email') : 'userName',
      sort ? sort.direction : 'asc',
      paginator ? paginator.pageIndex : 0,
      paginator ? paginator.pageSize : this.defaultPageSize
    );
    return this.adminUsersDataSource.loadUsers(Role.ADMIN, results);
  }

  refreshStandardUsers() {
    const sort = this.standardUsersGrid.getSort();
    const paginator = this.standardUsersGrid.getPaginator();
    const results: Observable<UsersApiResult> = this.usersSearchService.findUsers(
      this.standardUsersSearchInput.nativeElement.value,
      Role.STANDARD,
      sort ? (sort.active === 'name' ? 'userName' : 'email') : 'userName',
      sort ? sort.direction : 'asc',
      paginator ? paginator.pageIndex : 0,
      paginator ? paginator.pageSize : this.defaultPageSize
    );
    return this.standardUsersDataSource.loadUsers(Role.ADMIN, results);
  }

  search(roleType?: Role) {
    const role = roleType ? roleType : this.openedPanel;
    let searchKey: string;
    if (role === Role.STANDARD) {
      searchKey = this.standardUsersSearchInput.nativeElement.value;
      this.paginator = this.standardUsersTable.paginator;
    } else {
      searchKey = this.adminUsersSearchInput.nativeElement.value;
      this.paginator = this.adminUsersTable.paginator;
    }
    const results: Observable<UsersApiResult> = this.usersSearchService.findUsers(
      searchKey,
      role,
      this.sort ? (this.sort.active === 'name' ? 'userName' : 'email') : 'userName',
      this.sort ? this.sort.direction : 'asc',
      this.paginator ? this.paginator.pageIndex : 0,
      this.paginator ? this.paginator.pageSize : this.defaultPageSize
    );
    if ((this.openedPanel === Role.STANDARD) || (roleType === Role.STANDARD)) {
      return this.standardUsersDataSource.loadUsers(Role.STANDARD, results, this.paginator);
    } else {
      return this.adminUsersDataSource.loadUsers(Role.ADMIN, results, this.paginator);
    }
  }

  openStandardUsersPanel() {
    this.openedPanel = Role.STANDARD;
    this.stdPanelText = undefined;
    this.search();
  }

  openAdminUsersPanel() {
    this.openedPanel = Role.ADMIN;
    this.admPanelText = undefined;
    this.search();
  }

  editUser(data: UserInGrid) {
    this.editUserMode = true;
    this.userToEdit = data;
  }

  refreshGrid() {
    this.search();
  }

  returnToSettingsView() {
    this.editUserMode = false;
  }

  updateUser() {
    this.profileService.updateRole(this.userToEdit.email, { profileAccess: this.userToEdit.role } as ProfileRole)
      .subscribe(profile => {
        this.returnToSettingsView();
        const dialogConfirmRef = this.dialog.open(NotificationDialogComponent, this.getDialogConfig(this.userToEdit));
        dialogConfirmRef.afterClosed().subscribe(result => {
          const subscription = forkJoin([
            this.refreshAdminUsers(),
            this.refreshStandardUsers(),
          ]).subscribe(values => {
            subscription.unsubscribe();
          });
        });
      });
  }

  getDialogConfig(configData: any): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '416px';
    dialogConfig.height = '206px';
    dialogConfig.data = configData;
    dialogConfig.hasBackdrop = true;
    return dialogConfig;
  }

}
